import React, { useEffect, useState } from 'react'
import Styles from '../style/subCategoryMission.module.scss'
import CategoriesReward from '../component/CategoriesReward'
import SubcategoryMission from '../component/SubcategoryMission'
import Fav from '../../../../assets/theme6/fav.svg'
import { Link } from 'react-router-dom'
import Heart from '../../../../assets/theme6/heart.svg'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import BackArrow from '../../../../assets/svg/BackArrow';
import QuizWallicon from '../../../../assets/svg/QuizWallicon';
import BottomBar from '../component/BottomBar'


const SubCategoryMission = () => {

  window.scrollTo(0, 0);
  const { subcategoryId } = useParams();
  const navigate = useNavigate();

  return (
    <>
      <div className={Styles.container_rewarding_mission}>
        <div className={Styles.challenge_box_container_top}>
          <div className={Styles.icon_box}>
            <div onClick={() => navigate(-1)}>
              <BackArrow />
            </div>
            <QuizWallicon width={143} height={31} />
          </div>
          <div className={Styles.favorite_box}>
            <Link to={'/favorite-mission-reward'}>
              <img className={Styles.image} src={Fav} />
            </Link>
          </div>
        </div>
        <div className={Styles.challenge_box_container_bottom}>
          <SubcategoryMission categoryId={subcategoryId} />

            <div className={Styles.topFlex}>
              <div className={Styles.bottom_text}>Pick, <br /> Play & <span className={Styles.color_text}>Earn!</span></div>
              <div id="bottomDiv" className={Styles.jingle_text}>Made with <img style={{ position: 'relative', top: "5px" }} src={Heart} /></div>
            </div>

        </div>
        <BottomBar />
      </div>
    </>
  )
}

export default SubCategoryMission;